import { UserLocationModel } from "../../entities";
import { BaseODataRepository } from "../BaseODataRepository";

export class UserLocationODataRepo extends BaseODataRepository<UserLocationModel> {
  protected baseUrl = `/OData/userlocations`;
}
